module.exports = __webpack_public_path__ + "6499a0f0bae17c5ac5b091ca886245c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/press_teaser_201604_sz.jpg
// module id = 643
// module chunks = 0